import React, { Suspense } from "react";
import { useState, useEffect } from "react";
import styles from "../Splash.module.css";
import Loader from "../Loader";
import pills from "../pills.svg";
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import opcure_logo from "../opcure_logo.png";
import LoginHelp from "./LoginHelp";
import { useNavigate } from "react-router-dom";
import TextfieldStyled from "../components/TextfieldStyled/TextfieldStyled";
import { Error } from "@material-ui/icons";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../utils/AuthProvider";
import { useParams } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { LocalHospital } from "@mui/icons-material";
import { ButtonBase } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { Skeleton } from "@material-ui/lab";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";

// Sub-components (these could be moved to separate files for better organization)
const LoginForm = ({
  onSubmit,
  loading,
  loginerror,
  logout,
  clearLoginError,
}) => {
  // useEffect(() => {
  //   console.log("login form re-loaded");
  // }, []);

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const [loginform, setloginform] = useState({
    username: "",
    password: "",
  });

  const [loginFormState, setloginFormState] = useState({
    username: {
      error: false,
      helpertext: "",
    },
    password: {
      error: false,
      helpertext: "",
    },
  });

  const navigate = useNavigate();

  const handlesubmit = async (e) => {
    e.preventDefault();
    //reset loginform state
    setloginFormState({
      username: {
        error: false,
        helpertext: "",
      },
      password: {
        error: false,
        helpertext: "",
      },
    });

    let hasError = false;
    if (loginform.username.trim() === "") {
      setloginFormState((prev) => ({
        ...prev,
        username: {
          error: true,
          helpertext: "Username is required",
        },
      }));
      hasError = true;
    } else if (loginform.username !== loginform.username.trim()) {
      setloginFormState((prev) => ({
        ...prev,
        username: {
          error: true,
          helpertext: "Username cannot start or end with spaces",
        },
      }));
      hasError = true;
    }
    if (loginform.password.trim() === "") {
      setloginFormState((prev) => ({
        ...prev,
        password: {
          error: true,
          helpertext: "Password is required",
        },
      }));
      hasError = true;
    } else if (loginform.password !== loginform.password.trim()) {
      setloginFormState((prev) => ({
        ...prev,
        password: {
          error: true,
          helpertext: "Password cannot start or end with spaces",
        },
      }));
      hasError = true;
    }

    if (hasError) return;
    e.preventDefault();
    await onSubmit(loginform);
  };
  useEffect(() => {
    if (typeof clearLoginError === "function") {
      clearLoginError();
    }
  }, []);

  //handlechange: event handler for the input fields in the login form
  const handlechange = (e) => {
    // console.log("handleChange Called");
    let kew = { ...loginform }; //creates a copy of the loginform object
    //updates the input fields based on the event.target.name,
    kew[e.target.name] = e.target.value;
    // then updates the loginform state using setloginform
    setloginform(kew);
    if (typeof clearLoginError === "function") {
      clearLoginError();
    }
  };

  useEffect(() => {
    if (loginerror) {
      const lower = loginerror.toLowerCase();
      if (lower.includes("user")) {
        setloginFormState((prev) => ({
          ...prev,
          username: {
            error: true,
            helpertext: loginerror,
          },
        }));
      }

      if (lower.includes("password")) {
        setloginFormState((prev) => ({
          ...prev,
          password: {
            error: true,
            helpertext: loginerror,
          },
        }));
      }
    } else {
      setloginFormState({
        username: {
          error: false,
          helpertext: "",
        },
        password: {
          error: false,
          helpertext: "",
        },
      });
    }
  }, [loginerror]);

  return (
    <div className={styles.major}>
      <img
        style={{
          width: "130px",
          padding: "20px",
          paddingTop: "15px",
          height: "auto",
        }}
        src={opcure_logo}
        alt="tabeel_logo"
      />

      <form className={styles.formic}>
        <div className={styles.fieldContainer}>
          <TextfieldStyled
            placeholder="username"
            name="username"
            width="100%"
            color="white"
            label=""
            onChangehandler={handlechange}
            value={loginform.username}
            error={loginFormState.username.error}
            helpertext={loginFormState.username.helpertext}
            id="username"
          />
        </div>

        <div className={styles.fieldContainer}>
          <TextfieldStyled
            placeholder="password"
            type={showPassword ? "text" : "password"}
            name="password"
            width="100%"
            color="white"
            label=""
            onChangehandler={handlechange}
            value={loginform.password}
            error={loginFormState.password.error}
            helpertext={loginFormState.password.helpertext}
            id="password"
            icon={
              <IconButton onClick={handleTogglePassword} size="small">
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            }
          />
        </div>
      </form>

      {loginerror &&
        !loginerror.toLowerCase().includes("user") &&
        !loginerror.toLowerCase().includes("password") && (
        <div className={styles.error}>
          <Error fontSize="small" />
          {loginerror}
        </div>
      )}

      {/* This div contains the login button and a loading indicator. It uses inline styles for layout and spacing. */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "10px",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        {/* This button is used for logging in. When clicked, it calls the handlesubmit function */}
        <Button
          name="login"
          fullWidth
          variant="outlined"
          style={{
            textTransform: "none",
            boxSizing: "border-box",
            color: "#43677B",
            borderColor: "#43677B",
            fontWeight: "300",
          }}
          onClick={handlesubmit}
        >
          {/* button text changes based on the loading state */}
          {/* If loading is false, it shows "Login"; otherwise, it shows -> Signing in... 
  with a spinning loader. */}
          {!loading ? (
            "LOGIN"
          ) : (
            <>
              Signing in ...{" "}
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  marginLeft: "20px",
                }}
              >
                <Loader color="#6153BD" />
                {/*loader will shown inside button */}
              </div>
            </>
          )}
        </Button>
        {/* This div contains a message and a button for requesting login assistance. */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "grey",
          }}
        >
          <Typography style={{ fontWeight: "200" }} variant="body2">
            Trouble signing in?
          </Typography>
          {/* This button is used for login assistance. When clicked, it sets the 
    dialogVisibility state to true and dialogType to "login" */}
          <Button
            onClick={() => {
              navigate("/login/forgot-password");
            }}
            style={{
              textTransform: "none",
              fontWeight: "400",
              color: "#43677B",
            }}
            variant="text"
            size="small"
          >
            Click Here
          </Button>
        </div>
      </div>
    </div>
  );
};

const fetchClinicAddress = async (id, token) => {
  if (!id) return "";
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return fetch(`${process.env.REACT_APP_ENDPOINT}/clinic/${id}`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return "Failed to fetch clinic info";
      }
      return response.json();
    })
    .then((data) => data.address || "Address not available")
    .catch((error) => {
      console.error("Error fetching clinic info: " + error);
      return "Error fetching address";
    });
};

const ClinicSelect = ({ onSelect, logout }) => {
  const { user, token } = useAuth();
  //console.log(user)
  const [clinicInfo, setclinicInfo] = useState({});
  const [fetching, setfetching] = useState(false);
  useEffect(() => {
    const fetchAddresses = async () => {
      // Show skeleton placeholders while addresses are loading
      setfetching(true);
      try {
        // Fetch all clinic addresses in parallel to reduce total wait time
        const results = await Promise.all(
          user.map(async (clinic) => {
            try {
              const address = await fetchClinicAddress(clinic.id, token);
              return [clinic.id, address];
            } catch (error) {
              return [clinic.id, "Error fetching address"];
            }
          })
        );
        // Convert array of [id, address] pairs into an object keyed by clinic id
        setclinicInfo(Object.fromEntries(results));
      } finally {
        // Hide skeletons once all addresses have resolved (success or failure)
        setfetching(false);
      }
    };

    if (user && user.length > 0) {
      fetchAddresses();
    }
  }, [user]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "60%",
        alignItems: "flex-start",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          fontWeight: "300",

          fontSize: "16px",
          padding: "10px",
          paddingLeft: "20px",
          color: "#43677B",
        }}
      >
        <ButtonBase
          style={{
            display: "flex",
            alignItems: "center",
            color: "#43677B",
            fontSize: "15px",
          }}
          onClick={() => {
            logout();
          }}
        >
          <ArrowBack style={{ color: "#43677B" }} />
        </ButtonBase>
        Select Clinic
      </div>

      {user.length > 0 ? (
        user.map((clinic) => (
          <ButtonBase
            name="login"
            fullWidth
            variant="outlined"
            style={{ width: "100%", border: "0.2px solid #c0b7fa" }}
            onClick={() => onSelect(clinic)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                boxSizing: "border-box",
                alignItems: "center",
                color: "#43677B",
                fontWeight: "200",
                paddingLeft: "20px",
                width: "100%",
                fontSize: "18px",
                gap: "5px",
              }}
            >
              <LocalHospital style={{ color: "#43677B" }} />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "10px",
                }}
              >
                <div>{clinic.clinicName}</div>
                {/*<div style={{color:"gray",fontSize:"14px"}}>{"KP road Anantnag, 192101"}</div>*/}
                <div
                  style={{
                    color: "gray",
                    fontSize: "14px",
                    textAlign: "start",
                  }}
                >
                  {fetching ? (
                    <Skeleton variant="text" width={200} height={20} />
                  ) : (
                    clinicInfo[clinic.id]
                  )}
                </div>
              </div>
            </div>
          </ButtonBase>
        ))
      ) : (
        <div style={{ color: "#6153BD", marginLeft: "20px" }}>
          No Clinics Found
        </div>
      )}
    </div>
  );
};

const RoleSelect = ({ onSelect, logout }) => {
  const { currentClinic } = useAuth();
  // console.log("currentClinic:",currentClinic)
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "60%",
        alignItems: "flex-start",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
          fontWeight: "300",
          fontSize: "16px",
          padding: "10px",
          paddingLeft: "20px",
          color: "#43677B",
        }}
      >
        <ButtonBase
          style={{
            display: "flex",
            alignItems: "center",
            color: "#43677B",
            fontSize: "15px",
          }}
          onClick={() => {
            navigate("/clinics");
          }}
        >
          <ArrowBack style={{ color: "#43677B" }} />
        </ButtonBase>
        Select Role
      </div>

      {currentClinic && (
        <>
          {/* Scrollable roles container: limits vertical size and enables scrolling when
              the roles list is long. Adjust `maxHeight` as needed for different layouts. */}
          <div
            style={{
              width: "100%",
              maxHeight: "60vh",
              overflowY: "auto",
              paddingRight: "8px",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
            className="custom-scrollbar"
          >
            {/* Each role is rendered below as a `ButtonBase`. Inactive roles are disabled. */}
            {currentClinic.roles.map((role) => (
              <ButtonBase
                key={role.id}
                name="role"
                fullWidth
                variant="outlined"
                style={{
                  width: "100%",
                  border: "0.2px solid #c0b7fa",
                  borderColor: role?.status === "active" ? "#c0b7fa" : "gray",
                }}
                onClick={() => onSelect(role)}
                disabled={role?.status === "inactive"}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    boxSizing: "border-box",
                    alignItems: "center",
                    color: role?.status === "active" ? "#43677B" : "gray",
                    fontWeight: "200",
                    paddingLeft: "20px",
                    width: "100%",
                    fontSize: "18px",
                    gap: "5px",
                  }}
                >
                  <LocalHospital
                    style={{
                      color: role?.status === "active" ? "#43677B" : "gray",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "10px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      {`${role.position}`}
                      <span style={{ fontSize: "12px", fontWeight: "300" }}>
                        {role?.status === "inactive" && "(Inactive)"}
                      </span>
                    </div>
                    <div style={{ color: "gray", fontSize: "14px" }}>
                      {role.role.toUpperCase()}
                    </div>
                  </div>
                </div>
              </ButtonBase>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const ForgotPassword = () => {
  // Implement your forgot password form here
  return <LoginHelp />;
};

// Loading component for Suspense fallback
const Loading = () => <div>Loading...</div>;

const LoginMain = () => {
  const {
    login,
    user,
    selectClinic,
    loading,
    loginerror,
    logout,
    clearLoginError,
    currentClinic,
  } = useAuth();
  const navigate = useNavigate();
  const [selectedClinic, setSelectedClinic] = useState(null);

  useEffect(() => {
    //console.log("loginmain re-loaded")
  }, []);
  const handleLogin = async (credentials) => {
    // console.log("Credentials:",credentials)
    await login(credentials);
    //navigate('/clinics');
  };

  const handleClinicSelect = (clinic) => {
    setSelectedClinic(clinic);
    navigate(`/clinics/${clinic.id}/roles`);
  };

  const handleRoleSelect = (role) => {
    // selectedClinic is local state — it resets on page refresh. Fall back to currentClinic from AuthProvider (set by ProtectedClinicRoute).
    const clinic = selectedClinic ?? currentClinic;
    if (!clinic) {
      console.error("handleRoleSelect: no clinic selected");
      return;
    }
    selectClinic(parseInt(clinic.id), parseInt(role.id));
    navigate(`/`);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
      }}
    >
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            path="/login"
            element={
              user ? (
                <Navigate to="/clinics" />
              ) : (
                <LoginForm
                  onSubmit={handleLogin}
                  loading={loading}
                  loginerror={loginerror}
                  clearLoginError={clearLoginError}
                />
              )
            }
          />
          <Route
            path="/clinics"
            element={
              user ? (
                <ClinicSelect onSelect={handleClinicSelect} logout={logout} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route element={<ProtectedClinicRoute />}>
            <Route
              path="/clinics/:clinicId/roles"
              element={
                <RoleSelect
                  selectedClinic={selectedClinic}
                  onSelect={handleRoleSelect}
                  logout={logout}
                />
              }
            />
          </Route>
          <Route element={<ProtectedClinicRoleRoute />}>
            <Route
              path="/clinics/:clinicId/roles"
              element={
                <RoleSelect
                  selectedClinic={selectedClinic}
                  onSelect={handleRoleSelect}
                  logout={logout}
                />
              }
            />
          </Route>

          <Route path="/login/forgot-password" element={<ForgotPassword />} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Suspense>
    </div>
  );
};

// New components to handle params and protection

const ProtectedClinicRoute = () => {
  const { clinicId } = useParams();
  const { getVerifiedUser, setCurrentClinic } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const user = await getVerifiedUser();
        //console.log("user is",user)
        if (!user) {
          setIsAuthorized(false);
        } else {
          const selectedClinic = user.find(
            (clinic) => parseInt(clinic.id) === parseInt(clinicId)
          );
          if (selectedClinic) {
            setCurrentClinic(selectedClinic);
          }
          setIsAuthorized(!!selectedClinic);
        }
      } catch (e) {
        setIsAuthorized(false);
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    verifyUser();
  }, [getVerifiedUser, clinicId]);

  if (isLoading) {
    return <div>Loading...</div>; // Or a more sophisticated loading component
  }

  return isAuthorized ? <Outlet /> : <Navigate to="/login" />;
};

const ProtectedClinicRoleRoute = () => {
  const { clinicId, roleId, selectClinic } = useParams();
  const { getVerifiedUser, setCurrentClinic } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const user = await getVerifiedUser();
        //console.log("user is",user)
        if (!user) {
          setIsAuthorized(false);
        } else {
          const selectedClinic = user.find(
            (clinic) => parseInt(clinic.id) === parseInt(clinicId)
          );
          if (selectedClinic) {
            setCurrentClinic(selectedClinic);
          }
          setIsAuthorized(!!selectedClinic);
        }
      } catch (e) {
        setIsAuthorized(false);
        console.log(e);
      } finally {
        setIsLoading(false);
      }
    };

    verifyUser();
  }, [getVerifiedUser, clinicId]);

  if (isLoading) {
    return <div>Loading...</div>; // Or a more sophisticated loading component
  }

  return isAuthorized ? <Outlet /> : <Navigate to="/login" />;
};

export default LoginMain;
